module.exports = __webpack_public_path__ + "img/gq.e3b327fd.png";